import { useMemo } from 'react';
import { usePermissions } from 'context/PermissionsContext';
import { AI_PERMISSION_CODES } from 'permissions/constants/artificialIntelligencePermissionCodes';
import { MODULE_KEY_MAP } from 'permissions/constants/moduleKeyMap';

export { AI_PERMISSION_CODES };

const usePermissionsAI = () => {
  const { permissionsLoading, hasPermission, hasModuleAccess } =
    usePermissions();

  return useMemo(
    () => ({
      loading: permissionsLoading,
      canAccessModule: hasModuleAccess(MODULE_KEY_MAP.ARTIFICIAL_INTELLIGENCE),
      canAccessProtocols: hasPermission(AI_PERMISSION_CODES.PROTOCOLS),
      canViewSection: hasPermission(AI_PERMISSION_CODES.VIEW_SECTION),
      canCreateAnalysis: hasPermission(AI_PERMISSION_CODES.CREATE_ANALYSIS),
      canViewAnalysisDetail: hasPermission(
        AI_PERMISSION_CODES.VIEW_ANALYSIS_DETAIL
      ),
      canGoToCall: hasPermission(AI_PERMISSION_CODES.GO_TO_CALL),
      canAccessNoClientes: hasPermission(AI_PERMISSION_CODES.NO_CLIENTES),
      canViewNoClientesSection: hasPermission(
        AI_PERMISSION_CODES.NO_CLIENTES_VIEW_SECTION
      ),
      canViewNoClientesCall: hasPermission(
        AI_PERMISSION_CODES.NO_CLIENTES_VIEW_CALL
      ),
    }),
    [permissionsLoading, hasPermission, hasModuleAccess]
  );
};

export default usePermissionsAI;
